<button class="botonAval" mat-button routerLink="/actualizar_informacion">
    <span class="colorTextoAval">Actualizar Información</span>
</button>
